import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import FacilityInfoForm from "./facility-information";
import FacilityProcessInfo from "./facility-details";
import {
  mapFacilityDetails,
  mapToFacilityDetailsDeteleSaveReq,
  mapToFacilityDetailsReq,
} from "../../../sc-models/facility-product-dto";
// import { SCAppConfig } from '../../../../../shared/app-configs/sc-app-config';
import { useApi } from "../../../../../shared/hooks/useApi";
import useNotification from "../../../../../shared/hooks/useNotification";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import _ from "lodash";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  convertFacilityData,
  fetchFacilityDetails,
} from "./facility-setail-api";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";

interface FacilityInformation {
  isMainSite: string;
  facilityNo: string;
  facilityType: string;
  facilityOARId: string;
  lastAuditDate: string;
  farmCapacity?: string[];
  farmNoAnimals?: string[];
  iId?: string;
  // brandNames?: string;
  facilityStandard?: string[];
  name: string;
  address1: string;
  address2?: string;
  address3?: string;
  postcode: string;
  town: string;
  countryArea: string;
  stateProvince?: string;
  subcontractorLicenseNo?: string;
  certificationBody: string;
  expiryDate: string;
}
export interface FacilityProcessDetails {
  FacilityProccessCategoryCode: string;
  FacilityProcessUserSpecificTerm: string;
}
interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessDetails: FacilityProcessDetails[];
}

const initFacilityInfo: FacilityInformation = {
  isMainSite: "Y",
  facilityNo: "",
  facilityType: "",
  facilityOARId: "",
  lastAuditDate: "",
  farmCapacity: [],
  farmNoAnimals: [],
  iId: "",
  // brandNames: '',
  facilityStandard: [],
  name: "",
  address1: "",
  address2: "",
  address3: "",
  postcode: "",
  town: "",
  countryArea: "",
  stateProvince: "",
  subcontractorLicenseNo: "",
  certificationBody: "",
  expiryDate: "",
};

const initFacilityState: FacilityState = {
  facilityInfo: initFacilityInfo,
  facilityProcessDetails: [],
};

function mapToInitFacilityState(apiResponse: any): any {
  const facilityDetails = apiResponse?.facilityDetails;

  // If no facility details are returned, return an empty array
  if (!Array.isArray(facilityDetails) || facilityDetails.length === 0) {
    return [];
  }

  return facilityDetails.map((facility: any) => {
    const mappedFacilityInfo = {
      isMainSite: false,
      facilityNo: facility.facilityNo || "",
      facilityType: facility.facilityType || "",
      facilityOARId: facility.facilityOarId || "",
      lastAuditDate: facility.facilityLastAuditDate || "",
      farmCapacity: facility.facilityFarmCapacity || [],
      farmNoAnimals: facility.facilityFarmNoAnimals || [],
      iId: facility.facilityTeId || "",
      // brandNames: '', // Not provided by the API
      facilityStandard: facility.facilityStandard || [],
      name: facility.facilityName || "",
      address1: facility.facilityAddress1 || "",
      address2: facility.facilityAddress2 || "",
      address3: facility.facilityAddress3 || "",
      postcode: facility.facilityPostcode || "",
      town: facility.facilityTown || "",
      countryArea: facility.facilityCountryOrArea || "",
      stateProvince: facility.facilityStateOrProvince || "",
      subcontractorLicenseNo: facility.facilitySubcontractorLicenseNo || "",
      certificationBody:
        facility.facilityCbOfIndependentlyCertifiedSubcontractor || "",
      expiryDate:
        facility.facilityExpiryDateOfIndependentlyCertifiedSubcontractor || "",
    };

    const processDetails = Array.isArray(facility.facilityProcessDetails)
      ? facility.facilityProcessDetails.map((detail: any) => ({
        facilityProcessCategoryCode: detail.facilityProcessCategoryCode,
        facilityProcessCategoryUserSpecificTerm:
          detail.facilityProcessCategoryUserSpecificTerm,
      }))
      : [];

    return {
      ...mappedFacilityInfo,
      facilityProcessDetails: processDetails,
    };
  });
}
interface ShipmentData {
  facilityDetails: { facilityNo: string }[];
}
interface ScopeCertifiedDetailsComponentProps {
  onNextTab: () => Promise<void>;
}

const ScopeCertifiedDetailsComponent: React.FC<
  ScopeCertifiedDetailsComponentProps
> = ({ onNextTab }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [data, setData] = useState<FacilityState[]>([]);
  const [apiData, setAPIData] = useState<FacilityState[]>([]);
  const [mainFacility, setMainFacility] = useState<FacilityState | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [facilityData, setFacilityData] =
    useState<FacilityState>(initFacilityState);
  const [apiShipmentsData, setAPIShipmentsData] =
    useState<ShipmentData | null>();
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const { isRestrictPopUpSave } = useTransactionCertificateStore();

  const navigate = useNavigate();
  const {
    apiData: shipmentData,
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const { executeGet: executeNewGet, loading: loadingNewGet } = useApi();
  const { notify } = useNotification();
  const [getEditExistingFacilityDetails, setEditExistingFacilityDetails] =
    useState({
      index: -1,
      value: "",
    });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    replaceTableDatas,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("sc-facilitydetails");
  const facilityInfoRef = useRef<any>(null);
  const rawMaterialRef = useRef<any>(null);
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [facilityId, setFacilityId] = useState<string>("");
  const [facilityNo, setFacilityNo] = useState<string>("");
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [subsequentFacilityFlag, setSubsequentFacilityFlag] =
    useState<boolean>(false);
  const [scSubsequentFacilityButtonFlag, setScSubsequentFacilityButtonFlag] =
    useState<boolean>(false);
  const [scNoOfFarmsFlag, setScNoOfFarmsFlag] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });


  const setZustandInitialState = (initialState?: any) => {
    //set zustand state inital values
    const defaultState = initialState ?? initFacilityState;
    Object.entries(defaultState?.facilityInfo).forEach(([key, value]) => {
      updateField(key, value);
    });
    updateField("facilityProcessDetails", defaultState.facilityProcessDetails);
  };
  const loadFormData = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_FACILITY_DETAILS, {
        scId: SC_ID,
        limit: pagination?.pageSize,
        offset: pagination?.pageIndex * pagination?.pageSize
      });
      const result = mapFacilityDetails(response.data.response);
      setRowCount(response?.data?.no_of_records);
      setTableData(result);
      setAPIData(result);
      setMainFacility(
        result?.find(
          (facility) => facility?.facilityInfo?.facilityType === "MF"
        )
      );
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    if (SC_ID || !hasCreateSC) {
      loadFormData();
    } else {
      updateTableData([]);
    }
  }, [SC_ID, pagination?.pageIndex]);

  const toggleDrawer = () => {
    if (drawerOpen) {
      resetForm();
      setFacilityData(initFacilityState);
      setZustandInitialState();
      setFacilityId("");
      setFacilityNo("");
      setEditingIndex(-1);
    }
    setActiveStep(0);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: keyof FacilityState, updatedData: any) => {
    setFacilityData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const handleNext = async () => {
    const currentRef = activeStep === 0 ? facilityInfoRef : rawMaterialRef;
    Utills.cl("currentRef", currentRef);
    if (currentRef?.current) {
      const errors = await currentRef.current.validateForm();
      Object.keys(errors).forEach((fieldName) => {
        currentRef.current.setFieldTouched(fieldName, true, false);
      });
      if (Object.keys(errors).length === 0) {
        currentRef.current.submitForm();
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      } else {
        notify("Enter the mandatory fields", "error");
      }
    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));
  Utills.cl(facilityData, "data", data);

  const handleFinish = async () => {
    if (facilityData.facilityProcessDetails.length <= 0) {
      notify("Please add atleast one facility process", "error");
      return;
    }

    if (SC_ID) {
      Object.entries(facilityData.facilityInfo).forEach(([key, value]) => {
        if (typeof value === "string") {
          (facilityData.facilityInfo as any)[key] = value.trim();
        }
      });

      // Find the existing record in tableData that matches the facilityId
      const existingRecord = tableData.find(
        (item) => item.facilityInfo.facilityId === facilityId
      );
      let payloadFacilityId: string | null = facilityId;
      if (
        existingRecord &&
        existingRecord.facilityInfo.facilityNo !==
        facilityData?.facilityInfo?.facilityNo
      ) {
        payloadFacilityId = null;
      }

      const payload = mapToFacilityDetailsReq(facilityData, SC_ID, facilityId);

      // Check if facilityNo exists and has changed
      if (facilityId && payload.facilityDetails[0].facilityNo) {
        if (
          existingRecord &&
          existingRecord.facilityInfo.facilityNo !==
          payload.facilityDetails[0].facilityNo
        ) {
          const row = {
            original: {
              facilityInfo: {
                facilityNo: payload.facilityDetails[0].facilityNo,
                facilityId: facilityId,
              },
            },
          };

          onEditDelete(row);
          // The actual save will happen in handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If no changes to facility number, save directly
        handleSave(payload);
      } else if (!facilityId) {
        // This is a new facility, not an edit
        handleSave(payload);
      }
    }
  };

  const handleSave = async (payload: any) => {
    if (!SC_ID) {
      return;
    }
    let isSuccess = false;
    const queryParams = new URLSearchParams({
      scId: SC_ID,
    }).toString();

    const finalUrl = `${API_ROUTES.CREATE_FACILITY_DETAILS}?${queryParams}`;

    const result: any = await executePost(finalUrl, payload);
    if (result.status === 200) {
      isSuccess = true;
      notify("Data Saved Successfully", "success");
      setFacilityId("");
      setFacilityNo("");
      loadFormData();
      setFacilityData(initFacilityState);
      toggleDrawer();
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
    return isSuccess;
  };

const handleConfirmSave = async () => {
  try {
    if (!SC_ID) return;

    await executeDelete(`${API_ROUTES.DELETE_API}`, {
      scId: SC_ID,
      facilityId: facilityId,
      facilityNo: facilityNo,
    });

    notify("Previous facility successfully deleted", "success");

    // Save pending data
    if (pendingSave) {
      const isSaved = await handleSave(pendingSave);
      if (!isSaved) {
        notify("Save failed after deletion", "error");
      }
    }

    // Reset everything
    setDialogOpen(false);
    setFacilityId("");
    setFacilityNo("");
    setPendingSave(null);
    await loadFormData();
  } catch (error) {
    console.error("Error in handleConfirmSave:", error);
    notify("Failed to process the request", "error");
  }
};




  const onNext = () => {
    if (
      apiData.length == 0
    ) {
      notify("Please add atleast one Main Facility", "error");
    } else {
      navigate(`/sc/${formtype}/facility-product-details/${SC_ID}`);
    }
  };

  const handleDeleteSaveData = async () => {
    try {
      if (SC_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const facilityDetailsData: any = getCurrentTableData();
        setDeleteOnly(false);
        setDeleteSave(false);
        setEditSave(false);
        let isPostCreation = apiData?.length === 1 ? "no" : "yes";
        const facilityDetailsReq = mapToFacilityDetailsReq(
          data,
          SC_ID,
          isPostCreation
        );
        const result: any = await executePost(
          API_ROUTES.CREATE_FACILITY_DETAILS,
          facilityDetailsReq
        );
        if (result.status === 200) {
          notify("Saved Successfully", "success");
          // toggleDrawer()
          await loadFormData();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      notify("Error saving Facility Details", "error");
    }
  };
  const handleCancelSave = async () => {
    // Utills.cl("inside handleCancelSave", getDeleteSave())
    // if (!isDeleteOnly) {
    //   // toggleDrawer()
    // }
    // if (getEditExistingFacilityDetails.index != -1) {
    //   setEditExistingFacilityDetails({
    //     index: -1, value: ''
    //   })
    //   toggleDrawer()
    // }
    // setDeleteSave(false)
    // await loadFormData()
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  const onEdit = (row: any) => {
    const value = row?.original;
    setFacilityId(value.facilityInfo.facilityId);
    setFacilityNo(value.facilityInfo.facilityNo);
    if (SC_ID && value.facilityInfo.facilityId) {
      fetchFacilityDetails(executeNewGet, SC_ID, value.facilityInfo.facilityId)
        .then((data) => {
          const payload = convertFacilityData(data?.data);
          setFacilityData(payload);
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }

    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Facility will remove all the Associated Records, are you sure want to delete it`
    );
  };

const onEditDelete = (row: any) => {
  setFacilityId(row?.original?.facilityInfo.facilityId);
  setFacilityNo(row?.original?.facilityInfo.facilityNo);

  setDialogOpen(true);
  setPopUpBtnName("Save");
  setPopUpTitle("Confirm Save ?");
  setPopUpMessage(
    `Editing a Facility No. will remove all the Associated Facility Products, are you sure want to edit it`
  );
};



  const resetForm = () => {
    setZustandInitialState(initFacilityState);
  };
// In your ScopeCertifiedDetailsComponent file, update the steps array (around line 379)

const steps = [
  {
    label: "Facility Information",
    content: (
      <FacilityInfoForm
        formRef={facilityInfoRef}
        facilityData={facilityData.facilityInfo}
        mainSite={mainFacility}
        mfExists={
          apiData.length > 0 &&
          apiData.filter(
            (facility) => facility?.facilityInfo?.facilityType === "MF"
          ).length > 0
        }
        setFacilityData={(data) => handleDataUpdate("facilityInfo", data)}
        setSubsequentFacilityFlag={setSubsequentFacilityFlag}
        subsequentFacilityFlag={subsequentFacilityFlag}
        setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
        scNoOfFarmsFlag={scNoOfFarmsFlag}
        setScNoOfFarmsFlag={setScNoOfFarmsFlag}
        scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
        facilityInfoData={facilityData.facilityProcessDetails}
        // ADD THIS LINE - Check if we're editing an existing facility
        isEditMode={facilityId !== "" && facilityId !== null}
      />
    ),
  },
  {
    label: "Facility Process Details",
    content: (
      <FacilityProcessInfo
        facilityData={facilityData.facilityInfo}
        facilityProcessInfo={facilityData.facilityProcessDetails}
        setFacilityProcessInfo={(data) =>
          handleDataUpdate("facilityProcessDetails", data)
        }
        subsequentFacilityFlag={subsequentFacilityFlag}
        setSubsequentFacilityFlag={setSubsequentFacilityFlag}
        scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
        setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
        scNoOfFarmsFlag={scNoOfFarmsFlag}
        setScNoOfFarmsFlag={setScNoOfFarmsFlag}
      />
    ),
  },
];
  const actions: ActionButtonConfig[] = [
    ...activeStep !== 0 ? [{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as const,
      disabled: activeStep === 0,
    }] : [],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained",
      color: "primary",
      disabled: (activeStep === 1 && isRestrictPopUpSave) ||
        (activeStep === 1 && !scSubsequentFacilityButtonFlag),
    },
  ];

  const columns: MRT_ColumnDef<FacilityInformation>[] = [
    {
      accessorKey: "facilityInfo.facilityNo",
      header: "Facility No.",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityType",
      header: "Facility Type",
      minSize: 60,
      maxSize: 150,
    },
    // {
    //   accessorKey: "facilityInfo.facilityOarId",
    //   header: "OAR ID",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.lastAuditDate",
      header: "Last Audit Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.name",
      header: "Facility Name",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.postcode",
      header: "Postcode",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.countryArea",
      header: "Country Area",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.certificationBody",
      header: "Certification Body",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.expiryDate",
      header: "Expiry Date",
      minSize: 60,
      maxSize: 150,
    },
  ];
  console.log(tableData);
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitSC && (
              <StyledButton
                variant="contained"
                onClick={() => {
                  if (
                    apiData?.length === 0 ||
                    apiData.filter(
                      (facility) =>
                        facility?.facilityInfo?.facilityType === "MF"
                    ).length == 0
                  ) {
                    setFacilityData({
                      ...initFacilityState,
                      facilityInfo: {
                        ...initFacilityInfo,
                        facilityType: "MF",
                      },
                    });
                  }
                  toggleDrawer();
                }}
              >
                Add New Facility
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              paginations={pagination}
              setPaginations={setPagination}
              rowCount={rowCount}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitSC}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>No data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Facility"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {tableData.length > 0 && !drawerOpen && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: "0.5rem" }}>
              {/* <InnerButton onClick={handleSave}>Save & Next</InnerButton> */}
              <NavLink to="/sc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <InnerButton onClick={onNext}>Next</InnerButton>
            </Box>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ScopeCertifiedDetailsComponent;
